module.exports = __webpack_public_path__ + "static/flags/LG-433a47e7b45cbf8cfda5635066ff7167.gif";